import { render, staticRenderFns } from "./produkpembiayaan.vue?vue&type=template&id=153ca9c7&scoped=true"
import script from "./produkpembiayaan.vue?vue&type=script&lang=js"
export * from "./produkpembiayaan.vue?vue&type=script&lang=js"
import style0 from "./produkpembiayaan.vue?vue&type=style&index=0&id=153ca9c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153ca9c7",
  null
  
)

export default component.exports